export default "__VITE_ASSET__Bk4qiNA7__"